import React from 'react';
import RowColLayout from './RowColLayout';

const ErrorSection = ({ error, errors }) => {
  const hasFieldErrors = errors && Object.keys(errors).length > 0;
  // if (hasFieldErrors) console.log('Field errors from endpoint:', errors);
  if (!error && !hasFieldErrors) return null;

  return (
    <RowColLayout>
        <div className="alert alert-danger mt-3" role="alert">
        {error && <div>{error}</div>}

        {hasFieldErrors && (
            <ul className="mb-0">
            {Object.entries(errors).map(([field, message]) => (
                <li key={field}>{message}</li>
            ))}
            </ul>
        )}
        </div>
    </RowColLayout>
  );
};

export default ErrorSection;
